import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {GoodsGroupDto} from "../goods-group.dto";

export class SearchGoodsGroupRes extends SearchResultDto {

  public override readonly items: SearchGoodsGroupItem[] = [];

  constructor(init?: Partial<SearchGoodsGroupRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchGoodsGroupItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchGoodsGroupItem extends GoodsGroupDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchGoodsGroupItem>) {
    super(init);
    Object.assign(this, init);
  }

}
